import { AbstractBaseComponent } from '@shared/abstract-base/abstract-base.component';
import { Component } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Logger } from '@utils/logger';

const logger = Logger.getLogger('AccordionComponent');

interface AccordionContent {
  title: TitleBlock;
  accordionItems: Array<AccordionItem>;
  summary: { value: string };
}

interface AccordionItem {
  title: string;
  content: { value: string };
}

interface TitleBlock {
  name: string;
  displayName: string;
  level: string;
  preTitle: string;
  title: string;
  size: string;
}

@Component({
  selector: 'ft-accordion',
  templateUrl: './accordion.component.html',
})
export class AccordionComponent extends AbstractBaseComponent {
  constructor(private sanitizer: DomSanitizer) {
    super();
  }

  selected(event: any) {
    logger.debug(event);
  }

  get accordionDocument(): AccordionContent {
    return this.document?.getData<AccordionContent>();
  }

  get accordion(): AccordionItem[] {
    const accordionContent = this.accordionDocument;
    return accordionContent.accordionItems;
  }

  /**
   * Sanitazing HTML content
   * @param content - HTML content
   */
  sanitizeContent(content: string) {
    return this.sanitizer.bypassSecurityTrustHtml(content);
  }
}
